import React, { useState, useEffect } from 'react'
import { CommonDialog } from '@/components/common'
import { Login } from '../login'
import { AccountRecovery } from '../account-recovery'

const steps = {
  LOGIN: 'login',
  ACCOUNT_RECOVERY: 'account-recovery',
}

export const LoginDialog = ({ open, redirectUrl, onClose, onSuccess }) => {
  const [step, setStep] = useState(steps.LOGIN)

  useEffect(() => {
    if (open) setStep(steps.LOGIN)
  }, [open])

  const onAccountRecovery = () => {
    setStep(steps.ACCOUNT_RECOVERY)
  }

  return (
    <CommonDialog
      open={open}
      onClose={onClose}
      maxWidth='sm'
      fullWidth
      persistent={false}
    >
      {step === steps.LOGIN && (
        <Login
          redirectUrl={redirectUrl}
          onSuccess={onSuccess}
          onAccountRecovery={onAccountRecovery}
        />
      )}
      {step === steps.ACCOUNT_RECOVERY && (
        <AccountRecovery redirectUrl={redirectUrl} onSuccess={onSuccess} />
      )}
    </CommonDialog>
  )
}
